module.exports = __webpack_public_path__ + "5b843b820631e5ee79158978a8e0a175.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/eldar-vignette-preview-460.webp
// module id = 275
// module chunks = 0